
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import RoomData from '@/types/RoomData'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    HelperTooltip
  },

  props: {
    error: String
  },

  data: () => ({
    addName: '',
    addArea: '',
    roomError: ''
  }),

  computed: {
    ...mapFields({
      roomsData: 'roomsData',
      roomsForm: 'formValidity.roomsForm'
    })
  },

  methods: {
    addRoom () {
      this.roomError = ''
      if (this.addName.length && parseFloat(this.addArea) > 0) {
        const roomData = new RoomData()
        roomData.name = this.addName
        roomData.area = parseFloat(this.addArea)

        if ((this as any).roomsData.find((room: RoomData) => room.name === roomData.name)) { //eslint-disable-line
          this.roomError = 'Nem lehet két ugyanolyan nevű szoba.'
          return
        }

        this.$store.commit('addRoom', roomData)

        this.addName = ''
        this.addArea = '';

        (this.$refs.roomName as HTMLInputElement).focus()
      }
    },

    removeRoom (i: number) {
      this.$store.commit('removeRoom', i)
    }
  },

  watch: {
    roomsData (newVal) {
      (this as any).roomsForm = newVal.length > 0 //eslint-disable-line
    }
  }
})
